module.exports = __webpack_public_path__ + "img/files_icon.6fae3b57.png";